import { useMutation } from '@apollo/client';

import { SYNC_COGNITO_USER } from '../data/mutations/syncCognitoUser.gql';
import { GET_USER_COGNITO_STATE } from '../data/queries/getUserCognitoState.gql';

import { CognitoStateData } from './useGetUserCognitoState';

export interface SyncCognitoUserResult {
  __typename: string;
  state?: CognitoStateData;
  failureMessage?: string;
  message?: string;
  responseType?: string;
}

export interface UseSyncCognitoUserResult {
  syncUser: (userId: string) => Promise<SyncCognitoUserResult | null>;
  loading: boolean;
  error: Error | null;
}

export const useSyncCognitoUser = (): UseSyncCognitoUserResult => {
  const [syncMutation, { loading, error }] = useMutation(SYNC_COGNITO_USER, {
    errorPolicy: 'all',
  });

  const syncUser = async (
    userId: string
  ): Promise<SyncCognitoUserResult | null> => {
    const result = await syncMutation({
      variables: { id: userId },
      update: (cache, { data }) => {
        const response = data?.syncCognitoUser;
        if (
          response?.__typename === 'SyncCognitoUserSuccess' &&
          response.state
        ) {
          // Update the cache with the new Cognito state
          cache.writeQuery({
            query: GET_USER_COGNITO_STATE,
            variables: { id: userId },
            data: {
              userCognitoState: response.state,
            },
          });
        }
      },
    });

    return result.data?.syncCognitoUser || null;
  };

  return {
    syncUser,
    loading,
    error: error || null,
  };
};
